<script setup>

const colorMode = useColorMode()
const route = useRoute()

const { $listen } = useNuxtApp()

const props = defineProps({
	name: {
		type: String
	},
  options: {
    type: Array,
  },
})

const open = ref(false)
const selected = ref(null)
const emit = defineEmits(['update'])

if(Object.keys(route.query).length !== 0) {
	let option = null

	for (const [key, value] of Object.entries(route.query)) {
		if (key === props.name) {
			option = props.options.find(item => item.key === value)
			selected.value = option
			emit('update', { parameter: props.name , value: selected.value })
		}
	}
}

const getOptions = computed(() => {

	if (props.name === 'publishedYear') {
		return props.options.slice().reverse();
	}

	return props.options
})

const select = (option) => {
	selected.value = option
	open.value = false

	emit('update', { parameter: props.name , value: selected.value })
}

$listen('resetFilter', () => {
	selected.value = null
})

watch(() => route.query, () => {
  let option = null
	for (const [key, value] of Object.entries(route.query)) {
		if (key === props.name) {
			option = props.options.find(item => item.key === value)
			selected.value = option
			emit('update', { parameter: props.name , value: selected.value }, true)
		}
	}
});

</script>

<template>
	<div v-click-outside="() => open = false" class="relative dark:text-light text-dark text-sm xl:text-lg xl:min-w-[465px]">
		<div @click="open = !open" class="border dark:border-light dark:bg-dark border-dark bg-light py-[14px] px-6 cursor-pointer flex justify-between items-center">
			<span>{{ selected?.value || $t(`filter.${name}`) }}</span>
			<svg :class="{'rotate-180' : open}" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
				<path d="M10 14L16 20L22 14" :stroke="colorMode.preference === 'dark' ? '#F5F5F5' : '#1D1D1B'" stroke-width="2" stroke-linecap="square" stroke-linejoin="round"/>
			</svg>
		</div>
		<div v-if="open" class="absolute z-30 top-[100%] max-h-[675px] overflow-auto left-0 w-full border dark:border-light dark:bg-dark border-dark bg-light border-t-0">
			<div
				v-for="option in getOptions"
				:key="option.value"
				@click="select(option)"
				class="py-[14px] px-6 cursor-pointer dark:hover:bg-light dark:hover:text-dark hover:bg-dark hover:text-light transition-all duration-100"
			>
				{{ option.value }}
			</div>
		</div>
	</div>
</template>